/**
 * Hook for managing income input field
 */
import { useMemo, useState } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
import { z } from "zod";
// Income validation schema (in cents/smallest unit)
const incomeSchema = z.number().min(0, "Income cannot be negative");
export function useIncome() {
    const { formValues, setFormValues } = useSignupContext();
    const [touched, setTouched] = useState(false);
    const [blurred, setBlurred] = useState(false);
    const validation = useMemo(() => {
        const result = incomeSchema.safeParse(formValues.income);
        return {
            isValid: result.success,
            errorMessage: result.success
                ? null
                : (result.error.errors[0]?.message ?? "Invalid income"),
        };
    }, [formValues.income]);
    return useMemo(() => ({
        value: formValues.income,
        touched,
        blurred,
        isValid: validation.isValid,
        errorMessage: validation.errorMessage,
        setValue: setFormValues.setIncome,
        setTouched,
        setBlurred,
    }), [formValues.income, touched, blurred, validation, setFormValues.setIncome]);
}
